import * as api from "./api";
import * as modelsGet from "../models/get";

export function getFirstChangeset<T>(eventId: number): JQueryPromise<modelsGet.IChangeset<T>>
{
    var endpoint = new URI("api/changesets");
    endpoint.segment(eventId.toString());
    endpoint.segment("first");

    return api.get<modelsGet.IChangeset<T>>({
        endpoint: endpoint.href()
    });
}

export function getLastChangeset<T>(eventId: number): JQueryPromise<modelsGet.IChangeset<T>>
{
    var endpoint = new URI("api/changesets");
    endpoint.segment(eventId.toString());
    endpoint.segment("last");

    return api.get<modelsGet.IChangeset<T>>({
        endpoint: endpoint.href()
    });
}